import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';
import {OutlineButton, P2, ValueTitle} from '../Kit/Kit';
import Close from "react-icons/lib/md/close"


const ContentContainer = styled.div`
  display: flex;
  position: relative;
  overflow-y: auto;
  height: 100%;
  max-height: 500px;
  
  @media(min-width: 768px){
    max-height: 700px;
  }
`;

const ValuesContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: left;
  margin: auto;
  width: 75%;
  background: #fff;
  position: relative;
  padding: 50px 0;
  
  @media (min-width: 768px) {
   width: 100%;
   max-width: 800px;
  }
  
  h1 {
    margin: 20px 0;
  }
  
  svg {
    position: absolute;
    top: 1%;
    right: 1%;
    cursor: pointer;
    font-size: 30px;
    color: #909090
  }
  
  button {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    margin-left: 20px;
    
     @media(min-width: 768px){
      margin-left: 100px;
    }
    
    a{
      color: inherit;
      text-decoration: none;
      width: 100%;
      height: 100%;
      display: block;
    }
  }
`;

const JobTitle = ValueTitle.extend`
  padding: 0 20px;
  text-align: left;
  
  @media(min-width: 768px){
    padding: 0 100px;
  }
`;

const ValueText = P2.extend`
  padding: 0 20px;
  text-align: left;
  margin-bottom: 16px;
  
  @media(min-width: 768px){
    padding: 0 100px;
  }
  
  p{
    margin-bottom: 16px;
  }
`;

class JobModal extends React.Component {
    render() {
        const {isOpen, close, jobData} = this.props;
        const {
            position,
            location,
            department,
            job_description,
            email
        } = jobData;
        return (
          <Modal
            isOpen={isOpen}
            onRequestClose={() => close()}
            style={{
                overlay: {
                    position: `fixed`,
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: `rgba(0, 0, 0, 0.75)`,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                content: {
                    position: `relative`,
                    border: `none`,
                    background: `none`,
                    padding: 0,
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    overflow: `auto`,
                    WebkitOverflowScrolling: `touch`,
                },
            }}
            contentLabel="Modal"
          >
              <ContentContainer>
                  <ValuesContainer>
                      <JobTitle>Title: {position}</JobTitle>
                      <OutlineButton><a href={"mailto:" + email}>Email Us</a></OutlineButton>
                      <ValueText>Location: {location}</ValueText>
                      <ValueText>Department: {department}</ValueText>
                      <ValueText
                        dangerouslySetInnerHTML={{__html: job_description}}
                      />
                      <Close
                        onClick={() => close()}
                      />
                  </ValuesContainer>
              </ContentContainer>
          </Modal>
        );
    }
}

export default JobModal;



// WEBPACK FOOTER //
// ./src/components/Modals/JobModal.js